import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "components/ui";

const ReligionInfo = ({ religionInfo }) => {
  return (
    <div>
      <Card className="min-w-full">
        <CardHeader>
          <CardTitle>Religion Information</CardTitle>
        </CardHeader>
        <CardContent className="kt-scrollable-x-auto pb-3 p-0">
          <Table className="align-middle text-sm text-muted-foreground">
            <TableBody>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  Religious Strictness
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {religionInfo?.religion_strictness
                    ? Math.floor(Number(religionInfo?.religion_strictness))
                    : "N/A"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  Listen to music?
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {religionInfo?.is_listen_music === true ? "Yes" : "No"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  Attend mixed gatherings?
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {religionInfo?.is_attend_mix_gathering === true
                    ? "Yes"
                    : "No"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  Eat strictly halal when traveling?
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {religionInfo?.is_eat_halal_while_traveling === true
                    ? "Yes"
                    : "No"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                  Privacy Settings
                </TableCell>
                <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                  {religionInfo?.is_privacy_settings === true ? "Yes" : "No"}
                </TableCell>
              </TableRow>
              {(religionInfo?.gender === "Female" ||
                religionInfo?.gender === "female") && (
                <>
                  <TableRow>
                    <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                      Lifestyle Preferences
                    </TableCell>
                    <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                      {religionInfo?.lifestyle_preference
                        ? religionInfo?.lifestyle_preference
                        : "N/A"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="w-[40px] text-secondary-foreground font-normal text-left">
                      Expected Dowry (Optional)
                    </TableCell>
                    <TableCell className="w-28 text-[#2d2a33] font-semibold text-right">
                      {religionInfo?.expected_dowery
                        ? `${religionInfo.expected_dowery} ${
                            religionInfo.currency ?? ""
                          }`
                        : "N/A"}
                    </TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};

export default ReligionInfo;
